var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.5,
    height: 17.96,
    viewBox: "0 0 151.5 17.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M199.359,410.2h-5.4v3.828h5.072v.025L197.4,415.68h-3.441v10.747h-4.381V420h-.017v-9.086a2,2,0,0,1,1.229-1.786,5.162,5.162,0,0,1,2.523-.587l7.677-.013v.006Z",
    transform: "translate(-189.561 -408.467)",
    fill: "#8c8c8c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M346.033,420.167v9.386h-4.268l-.081-.977a4.115,4.115,0,0,1-1.148.638,3.714,3.714,0,0,1-1.326.339h-4.284q-2.167,0-2.167-1.617v-5.553q0-1.681,2.474-1.695l4.172-.026a6.856,6.856,0,0,1,2.15.939l.032-.118v-2.659h-8.6l1.7-1.667,7.547.011C346.021,417.169,346.033,420.167,346.033,420.167Zm-4.479,6.949v-3.963l-1.051-.783h-3.346V427.9h3.411Z",
    transform: "translate(-241.657 -411.607)",
    fill: "#8c8c8c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M220.679,420.167v9.386H216.41l-.08-.977a4.116,4.116,0,0,1-1.148.638,3.714,3.714,0,0,1-1.326.339h-4.284q-2.167,0-2.167-1.617v-5.553q0-1.681,2.474-1.695l4.172-.026a6.856,6.856,0,0,1,2.15.939l.032-.118v-2.659h-8.6l1.7-1.667,7.547.011C220.667,417.169,220.679,420.167,220.679,420.167Zm-4.479,6.949v-3.963l-1.051-.783H211.8V427.9h3.411Z",
    transform: "translate(-196.053 -411.607)",
    fill: "#8c8c8c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M397.4,427.9h-8.223v-4.028h8.877v-5.137a1.423,1.423,0,0,0-.389-1.173,3.943,3.943,0,0,0-2.15-.391H387.1a3.3,3.3,0,0,0-1.972.391,1.519,1.519,0,0,0-.339,1.173v9.7a1.019,1.019,0,0,0,.258.834,3.38,3.38,0,0,0,1.746.287H397.4Zm-8.223-9.048h4.4v3.234h-4.4Z",
    transform: "translate(-260.584 -411.613)",
    fill: "#8c8c8c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M319.783,427.9H311.56v-4.028h8.877v-5.137a1.423,1.423,0,0,0-.389-1.173,3.943,3.943,0,0,0-2.15-.391h-8.424a3.3,3.3,0,0,0-1.972.391,1.522,1.522,0,0,0-.339,1.173v9.7a1.019,1.019,0,0,0,.258.834,3.378,3.378,0,0,0,1.746.287h10.616Zm-8.223-9.048h4.4v3.234h-4.4Z",
    transform: "translate(-232.345 -411.613)",
    fill: "#8c8c8c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M284.966,408.462l-8.895,15.864-1.494-5.1,5.773-10.762h-5.788l-9.685,17.828-.01-.034-1.489-4.96,6.946-12.751-5.828.025-4.324,7.96,2.962,9.874h.892l.762,0,5.821-.016,2.959-5.348,1.6,5.228.016.138h5.811l9.761-17.942Z",
    transform: "translate(-215.25 -408.444)",
    fill: "#8c8c8c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M416.955,417.175l-1.791,1.343v-1.343h-4.381V429.56h4.4l-.013-9.26,1.788-1.341h2.809l1.778-1.778v-.006Z",
    transform: "translate(-270.043 -411.613)",
    fill: "#8c8c8c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M246.416,414.469a2.777,2.777,0,0,0-1.98-.523h-6.51v-5.513h-4.5v17.946H237.8l.13-1.06a2.444,2.444,0,0,0,2.353,1.06h4.464a2.118,2.118,0,0,0,1.753-.576,2,2,0,0,0,.26-1.178v-8.979A1.667,1.667,0,0,0,246.416,414.469Zm-4.075,10.249h-3.425l-.99-.917v-8.167h4.415Z",
    transform: "translate(-205.52 -408.433)",
    fill: "#8c8c8c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M367.618,417.175v8.265l-1.894,1.773h-.649l-1.894-1.773v-8.265h-4.4v8l4.834,4.38h3.563l4.834-4.38v-8Z",
    transform: "translate(-251.125 -411.613)",
    fill: "#8c8c8c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.2e7ec03bdab9d0daf580ade60e730416.svg";
export { ForwardRef as ReactComponent };